/* eslint-disable linebreak-style */
import React from 'react';
import PropTypes from 'prop-types';
import NavLink from 'components/NavLink';
import treatHrefLink from 'utils/treatHrefLink';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const MostSearchedItem = ({ item }) => (
  <NavLink
    basePath={publicRuntimeConfig.PUBLIC_URL}
    as={`${item?.permalink}`}
    to={treatHrefLink(item)}
    routerStrategy={'next'}
  >
    {item.name}
  </NavLink>
);

MostSearchedItem.defaultProps = {
  item: {
    name: '',
    permalink: '',
  }
};

MostSearchedItem.propTypes = {
  item: PropTypes.object
};

export default MostSearchedItem;
